import { Customer } from '@algoan/dashboard/model';
import { buildUrl } from '@algoan/dashboard/utils';

export type EnhancedCustomer = Customer & { personalDetails: { contact: { address?: string } } };

export const enhanceCustomer = (customer: Customer): EnhancedCustomer => {
  const contact = customer.personalDetails?.contact;

  const isAddressEmpty = !contact || (!contact.street && !contact.zipCode && !contact.city);
  const address = !isAddressEmpty
    ? `${contact?.street ?? ''}\n${contact?.zipCode ?? ''} ${contact?.city ?? ''}`
    : undefined;

  return {
    ...customer,
    personalDetails: { ...customer.personalDetails, contact: { ...customer.personalDetails?.contact, address } },
  };
};

export const getInvitationUrl = (customerId: string): string => {
  const requestParams = [{ key: 'customerId', value: customerId }];

  return buildUrl(`/invitation`, requestParams);
};
